export default "/app/global-wrapper-client/static/453ec0bbb426a973c1c21a17bb2e7e19.ttf";